<template>
  <van-popup v-model="show"
             position="left"
             closeable
             :style="{ width: '100%', height: '100%'}">
    <div class="filter">
      <div class="filter-hd">搜索查询</div>
      <div class="filter-bd">
        <Base-form-m ref="BaseFormM"
                     :form-items="formConfig"
                     :model-value.sync="searchParams"
                     submit-text="保存信息"
                     @submit="onSubmit">

          <!-- 提交按钮插槽 -->
          <template #actions>
            <van-button block
                        type="info"
                        native-type="submit">搜索</van-button>
            <van-button block
                        type="default"
                        style="margin-top: 10px;"
                        @click.prevent="onReset">重置</van-button>
          </template>
        </Base-form-m>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'searchFilter',
  data() {
    return {
      show: false,
      searchParams: {
        bankName: "",
        questionTag: "",
        questionType: "",
        content: "",
        status: "1"
      },
      questionTagOptions: [],
      questionTypeOptions: [],
    }
  },
  computed: {
    formConfig() {
      return [
        {
          prop: 'bankName',
          label: '题库名称',
          type: 'text',
          clearable: true
        },
        {
          prop: 'content',
          label: '试题名称',
          type: 'text',
          clearable: true
        },
        {
          prop: 'questionType',
          label: '试题题型',
          type: 'select',
          options: [...this.questionTypeOptions]
        },
        {
          prop: 'questionTag',
          label: '试题标签',
          type: 'select',
          options: [...this.questionTagOptions]
        }
      ]
    }
  },
  created() {
    this.getPageOptions()
  },
  methods: {
    getPageOptions() {
      Promise.all([
        this.getDicts('QUESTION_TAG'),
        this.getDicts('QUESTION_TYPE')
      ]).then(resList => {
        const [questionTagRes, questionTypeRes] = resList
        if (questionTagRes.status == 200) {
          this.questionTagOptions = questionTagRes.data.map(item => ({
            text: item.dictLabel,
            value: item.dictValue
          }))
        }
        if (questionTypeRes.status == 200) {
          this.questionTypeOptions = questionTypeRes.data.map(item => ({
            text: item.dictLabel,
            value: item.dictValue
          }))
        }
      })
    },
    open() {
      this.show = true
    },
    onSubmit() {
      this.show = false
      const params = { ...this.searchParams }
      this.$emit('handle-filter', { ...params })
    },
    onReset() {
      this.searchParams.bankName = ''
      this.searchParams.content = ''
      this.searchParams.questionTag = ''
      this.searchParams.questionType = ''
      this.onSubmit()
    }
  },
}
</script>

<style lang="less" scoped>
.filter {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.filter-hd {
  width: 100%;
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #eee;
  font-size: 16px;
  color: #333;
  text-align: center;
  box-sizing: border-box;
}
.filter-bd {
  width: 100%;
  height: calc(100% - 56px);
  padding: 10px;
  box-sizing: border-box;
  .btn-box {
    display: flex;
    align-items: center;
    margin-top: 16px;
    .van-button {
      margin: 0 10px;
    }
  }
}
</style>